<app-navbar *ngIf="showNavbar"></app-navbar>
<div class="page-header">
  <h3 class="page-title text-clr">
    <!-- <span class="page-title-icon bg-gradient-primary text-white mr-2">
      <i class="mdi mdi-home"></i>
    </span> -->
    Dashboard
  </h3>
</div>

<div class="row">
  <div class="col-sm-3">
    <div class="card  card-img-holder text-clr">
      <div class="card-body cursor-p" routerLink="/orders/orders">
        <div class="dashboard-card d-flex justify-content-between align-items-center">
          <div class="">
            <span class="count d-block">{{ formateCounts(dashboardCounts.totalOrders) }}</span>
            <span class="card-name d-block">Orders</span>
          </div>
          <div class="">
            <img src="../../assets/images/orders-1.svg" class="" alt="group1">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="card  card-img-holder text-clr">
      <div class="card-body cursor-p" routerLink="/sales">
        <div class="dashboard-card d-flex justify-content-between align-items-center">
          <div class="">
            <span class="count d-block">{{ formateCounts(dashboardCounts.totalSales) }}</span>
            <span class="card-name d-block">Sales</span>
          </div>
          <div class="">
            <img src="../../assets/images/sales.svg" class="" alt="group1">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="card  card-img-holder text-clr">
      <div class="card-body cursor-p" routerLink="/customers/customers">
        <div class="dashboard-card d-flex justify-content-between align-items-center">
          <div class="">
            <span class="count d-block">{{ formateCounts(dashboardCounts.totalCustomers) }}</span>
            <span class="card-name d-block">Customers</span>
          </div>
          <div class="">
            <img src="../../assets/images/customers-1.svg" class="" alt="group1">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="card  card-img-holder text-clr">
      <div class="card-body cursor-p" routerLink="/design">
        <div class="dashboard-card d-flex justify-content-between align-items-center">
          <div class="">
            <span class="count d-block">{{ formateCounts(dashboardCounts.totalDesigners) }}</span>
            <span class="card-name d-block">Brands</span>
          </div>
          <div class="">
            <img src="../../assets/images/Brands_icon.svg" class="" alt="group1">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">

  <div class="col-lg-12 mt-3">
    <div class="card  card-img-holder text-clr">
      <div class="card-body">
        <div class="row" *ngIf="showAnalytics">
          <div class="col-lg-12">
            <div class="card charts-graph">
              <div class="d-flex flex-wrap justify-content-between">
                <h4 class="card-title" style="color:white;">Sales</h4>
                <div class="filters d-flex">
                  <div class="d-flex">
                    <div class="chart-filters px-2">
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == '1M' }"
                        (click)="selectedApp('1M', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">1M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == '3M' }"
                        (click)="selectedApp('3M', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">3M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == '6M' }"
                        (click)="selectedApp('6M', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">6M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == '1Y' }"
                        (click)="selectedApp('1Y', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">1Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == 'YTD' }"
                        (click)="selectedApp('YTD', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">YTD</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == '3Y' }"
                        (click)="selectedApp('3Y', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">3Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedSalesType == 'MAX' }"
                        (click)="selectedApp('MAX', 'chatSalesOptions', 'selectedSalesType', 'graphdata1')">MAX</span>
                    </div>
                  </div>
                  <input type="text" *ngIf="showSalesDate" placeholder="Daterangepicker"
                    class="form-control d-flex ml-2 mb-1"
                    (bsValueChange)="dateSelected($event, 'sales', 'chatSalesOptions', 'selectedSalesType')"
                    placement="bottom right"
                     bsDaterangepicker>
                  <div class="chart-filters" >
                    <span class="calender-icon">
                      <img src="assets/images/white-calender.svg" class="" alt="..." (click)="showSalesDate = !showSalesDate">
                    </span>
                  </div>
                </div>

              </div>
              <div class="chart-section" *ngIf="chatSalesOptions">
                <highcharts-chart  [Highcharts]="Highcharts"
                  [options]="chatSalesOptions"></highcharts-chart>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-lg-12 p-0 grid-margin mt-3 stretch-card">
    <div class="card" style="background-color: #292D39;">
      <div class="card-body">
        <h4 class="card-title" style="color: white;">Latest Orders</h4>
        <div class="table-responsive">
          <table class="table table-sm  ">
            <thead>
              <tr>
                <th class="text-center">
                  Order<br /> ID
                </th>
                <th class="text-center">
                  Customer<br /> Name
                </th>
                <th class="text-center">
                  Customer<br /> Contact
                </th>
                <th class="text-center">
                  Order<br /> Date
                </th>
                <th class="text-center">
                  Delivery<br /> Type
                </th>
                <th class="text-center">
                  Delivery<br /> Agent
                </th>
                <th class="text-center">
                  Delivery<br /> Contact
                </th>
                <th class="text-center">
                  Tracking<br /> Number
                </th>
                <th class="text-center">
                  Order<br /> Status
                </th>
                <th class="text-center">
                  Assign<br /> Order
                </th>
                <th class="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of Orders  | slice:0:10; let i = index" class="dashboard_tr">
                <td>
                  {{ order.orderId }}
                </td>
                <td>
                  {{ order.userAddresses?.name }}
                </td>
                <td>
                  {{ order.userAddresses?.mobileNumber }}
                </td>
                <td>
                  {{ order.orderPlacedOn | date: "MM-dd-yyyy" }}
                </td>
                <td>
                  {{ order?.assignOrder?.deliveryType }}
                </td>
                <td>
                  {{ order?.assignOrder?.delivaryAgent }}
                </td>
                <td>
                  {{ order?.assignOrder?.deliveryMobileNo }}
                </td>
                <td>
                  {{ order?.assignOrder?.trackingUrl }}
                </td>
                <td>
                  <button [ngClass]="{
                  'text-success':order.transationStatusId === 6,
                  'text-return':order.transationStatusId === 7,
                  'text-secondary':order.transationStatusId === 3,
                  'text-danger':order.transationStatusId === 2,
                  'text-info':order.transationStatusId === 4,
                  'text-orderout':order.transationStatusId === 5,
                  'text-placed':order.transationStatusId === 1
                }"> <i class="fa fa-circle" aria-hidden="true" style="font-size: 8px;"></i> {{
                    getTransactionStatus(order.transationStatusId) }}</button>
                  <!-- {{ getTransactionStatus(order.transationStatusId) }} -->
                </td>
                <td class="text-center">
                  <div *ngIf="order.assignOrder; else assignOrder">
                    <img src="assets/images/assign-order.svg" class="green-tick" alt="">
                  </div>
                  <ng-template #assignOrder>
                    <button class="btn-mcred"
                    (click)="setAssignOrder(order)"> Set
                    </button>
                  </ng-template>
                </td>
                <td>
                  <a *ngIf="authenticationService.hasAccess('orderTransation',permitions.Edit)" (click)="
                      changeTransationStatus(
                        changeTransationModalContent,
                        order
                      )
                    ">
                    <i class="mdi mdi-pencil-box icon-sm tbtext-clr align-middle" style="color: #dae1f7!important;
                      font-size: 20px;
                      padding-left: 0px;
                      padding-right: 15px;
                      border-right: 1px solid #ffffff75;"></i>
                  </a>
                  <a *ngIf="authenticationService.hasAccess('orderTransation',permitions.View)">
                    &nbsp;&nbsp;
                    <i class="mdi mdi-eye icon-sm tbtext-clr align-middle" style="font-size: 20px;"
                      (click)="viewdetails(order)"></i>
                    &nbsp;&nbsp;
                    <!-- <i
                      class="mdi mdi-eye icon-sm tbtext-clr align-middle"
                      style="font-size: 20px;"
                    ></i> -->


                  </a>
                </td>

              </tr>

            </tbody>
          </table>
        </div>
        <a class="nav-link" routerLink="/orders/orders"
          style="cursor: pointer; color: #2AB0FF !important; float: right;">View All Orders
        </a>

      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-6">
    <div class="card  card-img-holder text-clr">
      <div class="card-body">
        <div class="row" *ngIf="showAnalytics">

          <div class="col-lg-12">
            <div class="card charts-graph">
              <div class="d-flex flex-wrap justify-content-between">
                <h4 class="card-title" style="color:white;">Customers</h4>
                <div class="filters d-flex">
                  <div class="d-flex">
                    <div class="chart-filters px-2">
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == '1M' }"
                        (click)="selectedApp('1M', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">1M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == '3M' }"
                        (click)="selectedApp('3M', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">3M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == '6M' }"
                        (click)="selectedApp('6M', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">6M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == '1Y' }"
                        (click)="selectedApp('1Y', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">1Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == 'YTD' }"
                        (click)="selectedApp('YTD', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">YTD</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == '3Y' }"
                        (click)="selectedApp('3Y', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">3Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedCustomerType == 'MAX' }"
                        (click)="selectedApp('MAX', 'chatCustomerOptions', 'selectedCustomerType', 'graphdata')">MAX</span>
                    </div>
                  </div>
                  <div class="date-picker-filter">
                    <div class="chart-filters" >
                      <span class="calender-icon">
                        <img src="assets/images/white-calender.svg" class="" alt="..."
                          (click)="showCustomerDate = !showCustomerDate">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-block mb-2">
                <input type="text" placeholder="Daterangepicker" *ngIf="showCustomerDate"
                  class="form-control w-50 float-right"
                  (bsValueChange)="dateSelected($event, 'orders', 'chatCustomerOptions', 'selectedCustomerType')"
                  placement="bottom right"
                  bsDaterangepicker>
              </div>
              <div class="chart-section" *ngIf="chatCustomerOptions">
                <highcharts-chart  [Highcharts]="Highcharts" [options]="chatCustomerOptions"></highcharts-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="card  card-img-holder text-clr">
      <div class="card-body">
        <div class="row" *ngIf="showAnalytics">

          <div class="col-lg-12">
            <div class="card charts-graph">
              <div class="d-flex flex-wrap justify-content-between">
                <h4 class="card-title" style="color:white;"> Orders</h4>
                <div class="filters d-flex">
                  <div class="d-flex">
                    <div class="chart-filters px-2">
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == '1M' }"
                        (click)="selectedApp('1M', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">1M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == '3M' }"
                        (click)="selectedApp('3M', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">3M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == '6M' }"
                        (click)="selectedApp('6M', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">6M</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == '1Y' }"
                        (click)="selectedApp('1Y', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">1Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == 'YTD' }"
                        (click)="selectedApp('YTD', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">YTD</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == '3Y' }"
                        (click)="selectedApp('3Y', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">3Y</span>
                      <span class="cursor-p" [ngClass]="{ 'active' : selectedOrderType == 'MAX' }"
                        (click)="selectedApp('MAX', 'chatOrderOptions', 'selectedOrderType', 'graphdata')">MAX</span>
                    </div>
                  </div>
                  <div class="date-picker-filter">
                    <div class="chart-filters" >
                      <span class="calender-icon">
                        <img src="assets/images/white-calender.svg" class="" alt="..." (click)="showOrderDate = !showOrderDate">
                      </span>
                    </div>
                  </div>

                </div>
              </div>
              <div class="d-block mb-2">
                <input type="text" placeholder="Daterangepicker" *ngIf="showOrderDate"
                  class="form-control w-50 float-right"
                  (bsValueChange)="dateSelected($event, 'orders', 'chatOrderOptions', 'selectedOrderType')"
                  placement="bottom right"
                   bsDaterangepicker>
              </div>
              <div class="chart-section" *ngIf="chatOrderOptions">
                <highcharts-chart  [Highcharts]="Highcharts" [options]="chatOrderOptions"></highcharts-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template style="width:900px" #changeTransationModalContent let-modal class="modal-fade" id="exampleModal-2"
  aria-labelledby="exampleModalLabel-2">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel-2" style="font-weight: bold;color: #2AB0FF; margin-left: 13px;">
        Change order Status
      </h5> <br>
      <button type="button" (click)="modal.dismiss()" class="btn" data-dismiss="modal" style="position: absolute;
      right: 5px;border-radius: 50%;top: 5px;width: 35px;height: 35px;">
        <i class="fa fa-times" style="color:#fff;font-size: 20px;
      margin-left: -3px;" aria-hidden="true"></i></button>
      <!-- <button
        type="button"
        class="close"
        (click)="modal.dismiss()"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button> -->



    </div>





    <form [formGroup]="transationForm">

      <div class="modal-body" style="padding: 2rem;">



        <div class=" form-group">
          <div class="row">
            <div class="col-md-3">
              <label for="gender" class="labels">Order Status</label>
            </div>
            <div class="col-md-1">
              :
            </div>
            <div class="col-md-8">
              <select class="form-control" id="transactionStatus" name="transactionStatus"
                formControlName="transactionStatus" style="font-size: 14px; color: black;">
                <option *ngFor="let transation of changebleTransations; let i = index"
                  style="font-size: 18px; font-size: 15px;" [ngValue]="transation.transactionId">
                  {{ transation.description }}</option>
              </select>
            </div>
          </div>
        </div>
        <div *ngIf="showTransationLink">

          <div class="row">
            <div class="col-md-3">
              <label for="metatagkeyWords" class="labels">Tracking Link:</label>
            </div>
            <div class="col-md-1">
              :
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control" placeholder="Tracking Link" name="trackingLink"
                formControlName="trackingLink" id="trackingLink" [required] />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="metatagkeyWords" class="labels">Service Provider


              </label>
            </div>
            <div class="col-md-1">
              :
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control" placeholder="Courier Services" name="courierServices"
                formControlName="courierServices" id="courierServices" />
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="container">
          <div style="margin-bottom: 100px;">
            <h4 style="color:#2AB0FF !important;    margin-top: 10px;     text-align: center;">Order Tracking Status
            </h4>
            <div class="track-checkbox">
              <div *ngFor="let track of trackList; let last = last; let i = index">
                <div class=" track-check-row">
                  <div style="    display: flex;
                             flex-wrap: wrap;
                             margin-right: -11px;
                             margin-left: -16px;">
                    <input id="track{{i}}" type="checkbox" [checked]="track.isCompleted" [disabled]="!track.isCompleted"
                      onclick="return false;" onkeydown="return false;" style="height: 20px;
                               width: 20px" />
                  </div>
                  <div class="row" style="margin-top: 20px;

                             margin-left: -37px;">
                    <label for="track{{i}}" class="track-label"><span style="font-weight: bold;font-size: 12px;">{{
                        track.description }}</span><br>
                      <span *ngIf="track.transactionOn">
                        on {{ track.transactionOn | date: "MM-dd-yyyy" }}<br>
                        at {{ track.transactionOn | date: "shortTime" }}</span>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div *ngIf="!last" [ngClass]="{
                               'trackline-solid': track.isCompleted,
                               'trackline-doted': !track.isCompleted
                             }">
                    <!-- <a
                               *ngIf="track.trackingLink"
                               [href]="track.trackingLink"
                               style="margin-left: 15px;    font-size: 13px;"
                               onclick="window.open(track.trackingLink,'_system'); return false;"
                               >Click here to track your shipment</a
                             > -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close()">
          Cancel
        </button>
        <button type="button" class="btn btn-success" (click)="updateTransationStatus()">
          Update
        </button>
      </div>
    </form>
  </div>
</ng-template>
<div class="row" *ngIf="false">
  <div class="col-md-5 grid-margin stretch-card">
    <div class="card">
      <ngb-datepicker #dp [(ngModel)]="date" (navigate)="date = $event.next" class="w-100 border-0"></ngb-datepicker>
    </div>
  </div>
  <div class="col-md-7 grid-margin stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Recent Updates</h4>
        <div class="d-flex">
          <div class="d-flex align-items-center mr-4 text-muted font-weight-light">
            <i class="mdi mdi-account-outline icon-sm mr-2"></i>
            <span>jack Menqu</span>
          </div>
          <div class="d-flex align-items-center text-muted font-weight-light">
            <i class="mdi mdi-clock icon-sm mr-2"></i>
            <span>October 3rd, 2018</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 pr-1">
            <img src="assets/images/dashboard/img_1.jpg" class="mb-2 mw-100 w-100 rounded" alt="image" />
            <img src="assets/images/dashboard/img_4.jpg" class="mw-100 w-100 rounded" alt="image" />
          </div>
          <div class="col-6 pl-1">
            <img src="assets/images/dashboard/img_2.jpg" class="mb-2 mw-100 w-100 rounded" alt="image" />
            <img src="assets/images/dashboard/img_3.jpg" class="mw-100 w-100 rounded" alt="image" />
          </div>
        </div>
        <div class="d-flex mt-5 align-items-top">
          <img src="assets/images/faces/face3.jpg" class="img-sm rounded-circle mr-3" alt="image" />
          <div class="mb-0 flex-grow">
            <h5 class="mr-2 mb-2">School Website - Authentication Module.</h5>
            <p class="mb-0 font-weight-light">
              It is a long established fact that a reader will be distracted by
              the readable content of a page.
            </p>
          </div>
          <div class="ml-auto">
            <i class="mdi mdi-heart-outline text-muted"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="false">
  <div class="col-md-7 grid-margin grid-margin-md-0 stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Project Status</h4>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>
                  #
                </th>
                <th>
                  Name
                </th>
                <th>
                  Due Date
                </th>
                <th>
                  Progress
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1
                </td>
                <td>
                  Herman Beck
                </td>
                <td>
                  May 15, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-success" role="progressbar" style="width: 25%;"
                      aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  2
                </td>
                <td>
                  Messsy Adam
                </td>
                <td>
                  Jul 01, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-danger" role="progressbar" style="width: 75%;"
                      aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  3
                </td>
                <td>
                  John Richards
                </td>
                <td>
                  Apr 12, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-warning" role="progressbar" style="width: 90%;"
                      aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  4
                </td>
                <td>
                  Peter Meggik
                </td>
                <td>
                  May 15, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-primary" role="progressbar" style="width: 50%;"
                      aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  5
                </td>
                <td>
                  Edward
                </td>
                <td>
                  May 03, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-danger" role="progressbar" style="width: 35%;"
                      aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  5
                </td>
                <td>
                  Ronald
                </td>
                <td>
                  Jun 05, 2015
                </td>
                <td>
                  <div class="progress">
                    <div class="progress-bar bg-gradient-info" role="progressbar" style="width: 65%;" aria-valuenow="65"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-5 stretch-card">
    <div class="card">
      <div class="card-body">
        <!-- <h4 class="card-title">Todo</h4> -->
        <!-- <app-todo></app-todo> -->
      </div>
    </div>
  </div>
</div>